export default __webpack_public_path__ + "static/media/myAthinaCourse.c87fc1e2.png";